/* eslint-disable sort-keys */
import darkPalette from './darkPalette'
import { typography as MuiTypography } from './typography'

import { MuiAccordion as Accordion } from './components/MuiAccordion'
import { MuiAccordionSummary as AccordionSummary } from './components/MuiAccordionSummary'
import { MuiAlert as Alert } from './components/MuiAlert'
import { MuiAlertTitle as AlertTitle } from './components/MuiAlertTitle'
import { MuiAutocomplete as Autocomplete } from './components/MuiAutocomplete'
import { MuiAvatar as Avatar } from './components/MuiAvatar'
import { MuiBadge as Badge } from './components/MuiBadge'
import { MuiButton as Button } from './components/MuiButton'
import { MuiCard as Card } from './components/MuiCard'
import { MuiCardActions as CardActions } from './components/MuiCardActions'
import { MuiCardContent as CardContent } from './components/MuiCardContent'
import { MuiCheckbox as Checkbox } from './components/MuiCheckbox'
import { MuiChip as Chip } from './components/MuiChip'
import { MuiContainer as Container } from './components/MuiContainer'
import { MuiCssBaseline as CssBaseline } from './components/MuiCssBaseline'
import { MuiDayCalendar as DayCalendar } from './components/MuiDayCalendar'
import { MuiDialogTitle as DialogTitle } from './components/MuiDialogTitle'
import { MuiDivider as Divider } from './components/MuiDivider'
import { MuiDrawer as Drawer } from './components/MuiDrawer'
import { MuiFormLabel as FormLabel } from './components/MuiFormLabel'
import { MuiIconButton as IconButton } from './components/MuiIconButton'
import { MuiInputAdornment as InputAdornment } from './components/MuiInputAdornment'
import { MuiInputBase as InputBase } from './components/MuiInputBase'
import { MuiInputLabel as InputLabel } from './components/MuiInputLabel'
import { MuiLinearProgress as LinearProgress } from './components/MuiLinearProgress'
import { MuiMenu as Menu } from './components/MuiMenu'
import { MuiMenuItem as MenuItem } from './components/MuiMenuItem'
import { MuiPagination as Pagination } from './components/MuiPagination'
import { MuiPaginationItem as PaginationItem } from './components/MuiPaginationItem'
import { MuiPaper as Paper } from './components/MuiPaper'
import { MuiPickersDay as PickersDay } from './components/MuiPickersDay'
import { MuiPickersArrowSwitcher as PickersArrowSwitcher } from './components/MuiPickersArrowSwitcher'
import { MuiPickersCalendarHeader as PickersCalendarHeader } from './components/MuiPickersCalendarHeader'
import { MuiOutlinedInput as OutlinedInput } from './components/MuiOutlinedInput'
import { MuiSelect as Select } from './components/MuiSelect'
import { MuiSkeleton as Skeleton } from './components/MuiSkeleton'
import { MuiSwitch as Switch } from './components/MuiSwitch'
import { MuiTab as Tab } from './components/MuiTab'
import { MuiTabs as Tabs } from './components/MuiTabs'
import { MuiTooltip as ToolTip } from './components/MuiTooltip'
import MuiUseMediaQuery from './components/MuiUseMediaQuery'

const darkTheme = {
  breakpoints: {
    values: {
      mobile: 0,
      tablet: 700,
      laptop: 1024,
      desktop: 1200,
      monitor: 1400
    }
  },
  components: {
    MuiAlert: Alert(darkPalette),
    MuiAlertTitle: AlertTitle(darkPalette),
    MuiAccordion: Accordion(darkPalette),
    MuiAccordionSummary: AccordionSummary(darkPalette),
    MuiAutocomplete: Autocomplete(darkPalette),
    MuiAvatar: Avatar(darkPalette),
    MuiBadge: Badge(darkPalette),
    MuiButton: Button(darkPalette),
    MuiCard: Card(darkPalette),
    MuiCardActions: CardActions(darkPalette),
    MuiCardContent: CardContent(darkPalette),
    MuiCheckbox: Checkbox(darkPalette),
    MuiChip: Chip(darkPalette),
    MuiContainer: Container(darkPalette),
    MuiCssBaseline: CssBaseline(darkPalette),
    MuiDayCalendar: DayCalendar(darkPalette),
    MuiDialogTitle: DialogTitle(darkPalette),
    MuiDivider: Divider(darkPalette),
    MuiDrawer: Drawer(darkPalette),
    MuiFormLabel: FormLabel(darkPalette),
    MuiIconButton: IconButton(darkPalette),
    MuiInputAdornment: InputAdornment(darkPalette),
    MuiInputBase: InputBase(darkPalette),
    MuiInputLabel: InputLabel(darkPalette),
    MuiLinearProgress: LinearProgress(darkPalette),
    MuiMenu: Menu(darkPalette),
    MuiMenuItem: MenuItem(darkPalette),
    MuiPagination: Pagination(darkPalette),
    MuiPaginationItem: PaginationItem(darkPalette),
    MuiPaper: Paper(darkPalette),
    MuiPickersDay: PickersDay(darkPalette),
    MuiPickersArrowSwitcher: PickersArrowSwitcher(darkPalette),
    MuiPickersCalendarHeader: PickersCalendarHeader(darkPalette),
    MuiOutlinedInput: OutlinedInput(darkPalette),
    MuiSelect: Select(darkPalette),
    MuiSkeleton: Skeleton(darkPalette),
    MuiSwitch: Switch(darkPalette),
    MuiTab: Tab(darkPalette),
    MuiTabs: Tabs(darkPalette),
    MuiTooltip: ToolTip(darkPalette),
    MuiUseMediaQuery
  },
  palette: darkPalette,
  spacing: 8,
  typography: MuiTypography(darkPalette)
}

export default darkTheme
